import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

/**
 * Get retailers list.
 * @returns {Object}
 */
export const retailersGet = (includeInactive) => {
    const query = includeInactive ? "?includeInactive=true" : "";
    return axios.get(`${apiUrl}retailers${query}`);
};

/**
 * Retailer get by id.
 * @param {Number} id
 * @returns {Object}
 */
export const retailersGetById = (id) =>
    axios.get(`${apiUrl}retailers/${id}`);

/**
 * Create new retailer.
 * @param {Object} data
 * @param {String} data.name
 * @param {Boolean} data.isInactive
 * @param {Number} data.oldRetailerId
 * @param {String} data.code
 * @param {String} data.code
 * @param {String|Object} [data.abbreviation=null]
 * @returns {Object}
 */
export const retailerCreate = (data) =>
    axios.post(`${apiUrl}retailers`, data);

/**
 * Update existing retailer.
 * @param {Number} id
 * @param {Object} data
 * @param {String} data.name
 * @param {Boolean} data.isInactive
 * @param {Number} data.oldRetailerId
 * @param {String} data.code
 * @param {String} data.code
 * @param {String|Object} [data.abbreviation=null]
 * @returns {Object}
 */
export const retailerUpdate = (id, data) =>
    axios.put(`${apiUrl}retailers/${id}`, data);

/**
 * Delete retailer.
 * @param {Number} id
 * @returns {Object}
 */
export const retailerDelete = (id) =>
    axios.delete(`${apiUrl}retailers/${id}`);
